import { useCallback, useState } from 'react';

// useState for a set or an object that is remembered in this browser (what the user has folded in a list), so it is the same when
// the page is visited again. The setter takes a value or a function, like useState's.
const read = (key, fallback) => { try { const v = JSON.parse(localStorage.getItem(key)); return v === null || v === undefined ? fallback : v; } catch { return fallback; } };
const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* not remembered */ } };

export function usePersistentSet(key) {
  const [value, setValue] = useState(() => new Set(read(key, [])));
  const update = useCallback((u) => setValue((prev) => {
    const next = typeof u === 'function' ? u(prev) : u;
    write(key, [...next]);
    return next;
  }), [key]);
  return [value, update];
}

export function usePersistentObject(key) {
  const [value, setValue] = useState(() => read(key, {}));
  const update = useCallback((u) => setValue((prev) => {
    const next = typeof u === 'function' ? u(prev) : u;
    write(key, next);
    return next;
  }), [key]);
  return [value, update];
}
